import allResources from './allResources';

export default allResources;
